<template>
  <div class="layout-wrap" :class="orientationClass">
    <Loading />
    <div class="webview-header">
      <button type="button" class="close-button" @click="onClose"></button>
    </div>
    <div class="webview-content">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'WebViewLayout',
}
</script>

<script setup lang="ts">
  import { computed, defineAsyncComponent } from 'vue'
  import { useWebViewModeStore } from '@/stores/webViewMode'
  import { sendConstructionCreateClosed } from '@/utils/webViewBridge'

  const Loading = defineAsyncComponent(() => import('@/components/ui/Loading.vue'))

  const webViewModeStore = useWebViewModeStore()

  const orientationClass = computed(() => {
    return webViewModeStore.isPortrait ? 'webview-portrait' : 'webview-landscape'
  })

  const onClose = () => {
    sendConstructionCreateClosed()
  }
</script>

<style scoped lang="scss">
.layout-wrap {
  height: 100%;
}

.webview-header {
  position: fixed;
  z-index: 10;
  width: 100%;
  background-color: #1A2274;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
}

.close-button {
  width: 50px;
  height: 50px;
  border: none;
  background: #FFF url("@/assets/icons/arrow_back_blue.svg") no-repeat center center;
  cursor: pointer;
}

.webview-content {
  height: 100%;
}
</style>
